/* eslint-disable import/order */
import { EpilotSVG } from './Epilot';
import { EditSVG } from './Edit';
import { OpenInNewSVG } from './OpenInNew';
import { ShareSVG } from './Share';
import { DeleteSVG } from './Delete';
import { AddSVG } from './Add';
import { AddCircleSVG } from './AddCircle';
import { PurposeSVG } from './Purpose';
import { CheckSVG } from './Check';
import { CheckCircleSVG } from './CheckCircle';
import { WarningSVG } from './Warning';
import { ErrorSVG } from './Error';
import { InfoSVG } from './Info';
import { HelpSVG } from './Help';
import { ContentCopySVG } from './ContentCopy';
import { FileCopySVG } from './FileCopy';
import { FileCopyOffSVG } from './FileCopyOff';
import { FilterAltSVG } from './FilterAlt';
import { FilterAltOffSVG } from './FilterAltOff';
import { DataObjectSVG } from './DataObject';
import { NotificationsSVG } from './Notifications';
import { VisibilitySVG } from './Visibility';
import { VisibilityOffSVG } from './VisibilityOff';
import { CloseSVG } from './Close';
import { ExpandMoreSVG } from './ExpandMore';
import { ExpandLessSVG } from './ExpandLess';
import { ChevronRightSVG } from './ChevronRight';
import { ChevronLeftSVG } from './ChevronLeft';
import { SearchSVG } from './Search';
import { SettingsSVG } from './Settings';
import { CalendarSVG } from './Calendar';
import { CalendarTodaySVG } from './CalendarToday';
import { ExploreSVG } from './Explore';
import { DragIndicatorSVG } from './DragIndicator';
import { DownloadSVG } from './Download';
import { SaveSVG } from './Save';
import { RefreshSVG } from './Refresh';
import { MenuSVG } from './Menu';
import { LinkSVG } from './Link';
import { AddLinkSVG } from './AddLink';
import { LoginSVG } from './Login';
import { LogoutSVG } from './Logout';
import { LockSVG } from './Lock';
import { LockOpenSVG } from './LockOpen';
import { TableSVG } from './Table';
import { TableEditSVG } from './TableEdit';
import { AttributesSVG } from './Attributes';
import { ArrowRightSVG } from './ArrowRight';
import { ArrowLeftSVG } from './ArrowLeft';
import { DashboardSVG } from './Dashboard';
import { OpportunitySVG } from './Opportunity';
import { OrderSVG } from './Order';
import { ContactSVG } from './Contact';
import { AccountSVG } from './Account';
import { ContractSVG } from './Contract';
import { BillingAccountSVG } from './BillingAccount';
import { RequestSVG } from './Request';
import { MessageSVG } from './Message';
import { ThreadSVG } from './Thread';
import { MarkMessageUnreadSVG } from './MarkMessageUnread';
import { MarkNoteUnreadSVG } from './MarkNoteUnread';
import { MarkNoteReadSVG } from './MarkNoteRead';
import { MarkMessageReadSVG } from './MarkMessageRead';
import { MoveToInboxSVG } from './MoveToInbox';
import { FileSVG } from './File';
import { EmailTemplateSVG } from './EmailTemplate';
import { FileSharedSVG } from './FileShared';
import { NoteSVG } from './Note';
import { DocumentSVG } from './Document';
import { TemplatesSVG } from './Templates';
import { ProductSVG } from './Product';
import { PriceSVG } from './Price';
import { TaxSVG } from './Tax';
import { SubmissionSVG } from './Submission';
import { PartnerSVG } from './Partner';
import { PartneringSVG } from './Partnering';
import { MeterSVG } from './Meter';
import { EntitySVG } from './Entity';
import { WebhookSVG } from './Webhook';
import { DesignSVG } from './Design';
import { WorkflowSVG } from './Workflow';
import { BlueprintSVG } from './Blueprint';
import { PhaseSVG } from './Phase';
import { AutomationSVG } from './Automation';
import { AutomationCircleSVG } from './AutomationCircle';
import { JourneySVG } from './Journey';
import { RelationsSVG } from './Relations';
import { AvailabilitySVG } from './Availability';
import { FilterSVG } from './Filter';
import { SortSVG } from './Sort';
import { DesktopSVG } from './Desktop';
import { PhoneSVG } from './Phone';
import { ImageSVG } from './Image';
import { PauseSVG } from './Pause';
import { PlaySVG } from './Play';
import { AlarmSVG } from './Alarm';
import { ArrowCircleLeftSVG } from './ArrowCircleLeft';
import { MoreVertSVG } from './MoreVert';
import { MoreHorizSVG } from './MoreHoriz';
import { MoreHorizCircleSVG } from './MoreHorizCircle';
import { QuestionMarkSVG } from './QuestionMark';
import { SkipSVG } from './Skip';
import { ChecklistSVG } from './Checklist';
import { PersonCheckSVG } from './PersonCheck';
import { PersonAddSVG } from './PersonAdd';
import { CommentSVG } from './Comment';
import { StarSVG } from './Star';
import { StoreSVG } from './Store';
import { ExclamationSVG } from './Exclamation';
import { PrimarySVG } from './Primary';
import { PriceMappingSVG } from './PriceMapping';
import { ReplySVG } from './Reply';
import { ReplyAllSVG } from './ReplyAll';
import { ResizeSVG } from './Resize';
import { PortalSVG } from './Portal';
import { ThumbUpSVG } from './ThumbUp';
import { ThumbDownSVG } from './ThumbDown';
import { EntityBuilderSVG } from './EntityBuilder';
import { ConnectionSVG } from './Connection';
import { CheckBoxSVG } from './CheckBox';
import { NumberSVG } from './Number';
import { RadioButtonSVG } from './RadioButton';
import { TextFieldSVG } from './TextField';
import { AddressSVG } from './Address';
import { SignatureSVG } from './Signature';
import { UploadSVG } from './Upload';
import { CalculatorSVG } from './Calculator';
import { PaymentSVG } from './Payment';
import { ConsentSVG } from './Consent';
import { ParagraphSVG } from './Paragraph';
import { ActionSVG } from './Action';
import { AttributeEditSVG } from './AttributeEdit';
import { SummarySVG } from './Summary';
import { SolarSVG } from './Solar';
import { SDKSVG } from './SDK';
import { LookupSVG } from './Lookup';
import { PreviousProviderSVG } from './PreviousProvider';
import { SuccessConfirmationSVG } from './SuccessConfirmation';
import { CategorySVG } from './Category';
import { ExpandContentSVG } from './ExpandContent';
import { CollapseContentSVG } from './CollapseContent';
import { MapSVG } from './Map';
import { SunSVG } from './Sun';
import { FrameSVG } from './Frame';
import { EnergySavingsLeafSVG } from './EnergySavingsLeaf';
import { AvgTimeSVG } from './AvgTime';
import { CallSVG } from './Call';
import { MailSVG } from './Mail';
import { CableSVG } from './Cable';
import { StackSVG } from './Stack';
import { TwoColumnsSVG } from './TwoColumns';
import { DiagramSVG } from './Diagram';
import { RepeatSVG } from './Repeat';
import { MoveDownSVG } from './MoveDown';
import { StepOverSVG } from './StepOver';
import { PendingSVG } from './Pending';
import { PauseCircleSVG } from './PauseCircle';
import { ConditionSVG } from './Condition';
import { ConditionCircleSVG } from './ConditionCircle';
import { NoteStackSVG } from './NoteStack';
import { DoubleThumbsUpSVG } from './DoubleThumbsUp';
import { AIStarSVG } from './AIStar';
import { AIComposeSVG } from './AICompose';
import { LabelSVG } from './Label';
import { LabelOffSVG } from './LabelOff';
import { RemoveSVG } from './Remove';
import { FileManagerSVG } from './FileManager';
import { BoltSVG } from './Bolt';
import { ViewDaySVG } from './ViewDay';
import { FlipSVG } from './Flip';
import { UpdateSVG } from './Update';
import { ScheduleSVG } from './Schedule';
import { CalendarClockSVG } from './CalendarClock';
import { ReadMoreSVG } from './ReadMore';
import { KeepSVG } from './Keep';
import { KeepOffSVG } from './KeepOff';
import { GridSVG } from './Grid';
import { GridViewSVG } from './GridView';
import { AutoDeleteSVG } from './AutoDelete';
import { DeleteForeverSVG } from './DeleteForever';
import { RestoreSVG } from './Restore';
import { ForestSVG } from './Forest';
import { FuelSVG } from './Fuel';
import { RecyclingSVG } from './Recycling';
import { DangerousSVG } from './Dangerous';
import { ApartmentSVG } from './Apartment';
import { PlayCircleSVG } from './PlayCircle';
import { AddTaskSVG } from './AddTask';
import { RavenSVG } from './Raven';
import { DriveFileMoveSVG } from './DriveFileMove';
import { MergeSVG } from './Merge';
import { ArchiveSVG } from './Archive';
import { UnarchiveSVG } from './Unarchive';
import { LocationAwaySVG } from './LocationAway';
import { LinkOffSVG } from './LinkOff';
import { AccountCircleOffSVG } from './AccountCircleOff';
import { SendSVG } from './Send';
import { UndoSVG } from './Undo';
import { ChipExtractionSVG } from './ChipExtraction';
import { TargetSVG } from './Target';
import { CampaignSVG } from './Campaign';
import { TicketSVG } from './Ticket';
import { FlowSVG } from './Flow';
import { CardsSVG } from './Cards';
import { TaskSVG } from './Task';
import { WidgetsSVG } from './Widgets';
import { AttachSVG } from './Attach';
import { DescriptionSVG } from './Description';
import { StackedEmailSVG } from './StackedEmail';
import { ChatBubbleSVG } from './ChatBubble';
import { GlobeSVG } from './Globe';
import { HomeSVG } from './Home';
import { EuroSVG } from './Euro';
import { ToggleSVG } from './Toggle';
import { NumbersSVG } from './Numbers';
import { BuildingSVG } from './Building';
import { MoveSVG } from './Move';
import { MoveInSVG } from './MoveIn';
import { ConditionGraphSVG } from './ConditionGraph';
import { FeatureSearchSVG } from './FeatureSearch';
import { SynchronizeSVG } from './Synchronize';
import { ArrowUpSVG } from './ArrowUp';
import { ArrowDownSVG } from './ArrowDown';
import { RegularExpressionSVG } from './RegularExpression';
import { InboxSVG } from './Inbox';
import { EditDocumentSVG } from './EditDocument';
import { LeftPanelCloseSVG } from './LeftPanelClose';
import { LeftPanelOpenSVG } from './LeftPanelOpen';
import { HandSVG } from './Hand';
import { SmartToySVG } from './SmartToy';
import { AdminPanelSettingsSVG } from './AdminPanelSettings';
import { SyncSVG } from './Sync';
import { SyncDisabledSVG } from './SyncDisabled';
import { DoNotDisturbOnSVG } from './DoNotDisturbOn';
import { SwapSVG } from './Swap';
import { ExpandSVG } from './Expand';
import { CollapseSVG } from './Collapse';
import { ActionKeySVG } from './ActionKey';
import { BarChartSVG } from './BarChart';
import { DatabaseSVG } from './Database';
import { CouponSVG } from './Coupon';
import { ProductRecommendationSVG } from './ProductRecommendation';
import { LocationSVG } from './Location';
import { LabsSVG } from './Labs';
import { FormatBoldSVG } from './FormatBold';
import { FormatItalicSVG } from './FormatItalic';
import { FormatUnderlinedSVG } from './FormatUnderlined';
import { FormatStrikethroughSVG } from './FormatStrikethrough';
import { HeadingSVG } from './Heading';
import { FormatListBulletedSVG } from './FormatListBulleted';
import { FormatListNumberedSVG } from './FormatListNumbered';
import { CodeSVG } from './Code';
import { GroupSVG } from './Group';
import { FolderLimitedSVG } from './FolderLimited';
import { AnalyticsSVG } from './Analytics';
import { AreaChartSVG } from './AreaChart';
import { TrendingSVG } from './Trending';
import { LibrarySVG } from './Library';
import { ChartLineSVG } from './ChartLine';

import type { IconProps } from '../types';
import type { SvgStringOpts } from '../svgString';

export const svgMap = {
  epilot: EpilotSVG,
  edit: EditSVG,
  open_in_new: OpenInNewSVG,
  share: ShareSVG,
  delete: DeleteSVG,
  add: AddSVG,
  add_circle: AddCircleSVG,
  purpose: PurposeSVG,
  check: CheckSVG,
  check_circle: CheckCircleSVG,
  warning: WarningSVG,
  error: ErrorSVG,
  info: InfoSVG,
  help: HelpSVG,
  content_copy: ContentCopySVG,
  file_copy: FileCopySVG,
  file_copy_off: FileCopyOffSVG,
  filter_alt: FilterAltSVG,
  filter_alt_off: FilterAltOffSVG,
  data_object: DataObjectSVG,
  notifications: NotificationsSVG,
  visibility: VisibilitySVG,
  visibility_off: VisibilityOffSVG,
  close: CloseSVG,
  expand_more: ExpandMoreSVG,
  expand_less: ExpandLessSVG,
  chevron_right: ChevronRightSVG,
  chevron_left: ChevronLeftSVG,
  search: SearchSVG,
  settings: SettingsSVG,
  calendar: CalendarSVG,
  calendar_today: CalendarTodaySVG,
  explore: ExploreSVG,
  drag_indicator: DragIndicatorSVG,
  download: DownloadSVG,
  save: SaveSVG,
  refresh: RefreshSVG,
  menu: MenuSVG,
  link: LinkSVG,
  add_link: AddLinkSVG,
  login: LoginSVG,
  logout: LogoutSVG,
  lock: LockSVG,
  lock_open: LockOpenSVG,
  table: TableSVG,
  table_edit: TableEditSVG,
  attributes: AttributesSVG,
  arrow_right: ArrowRightSVG,
  arrow_left: ArrowLeftSVG,
  dashboard: DashboardSVG,
  opportunity: OpportunitySVG,
  order: OrderSVG,
  contact: ContactSVG,
  account: AccountSVG,
  contract: ContractSVG,
  billing_account: BillingAccountSVG,
  request: RequestSVG,
  message: MessageSVG,
  thread: ThreadSVG,
  mark_email_unread: MarkMessageUnreadSVG,
  mark_note_unread: MarkNoteUnreadSVG,
  mark_note_read: MarkNoteReadSVG,
  mark_email_read: MarkMessageReadSVG,
  move_to_inbox: MoveToInboxSVG,
  file: FileSVG,
  email_template: EmailTemplateSVG,
  file_shared: FileSharedSVG,
  note: NoteSVG,
  document: DocumentSVG,
  templates: TemplatesSVG,
  product: ProductSVG,
  price: PriceSVG,
  tax: TaxSVG,
  submission: SubmissionSVG,
  partner: PartnerSVG,
  partnering: PartneringSVG,
  meter: MeterSVG,
  entity: EntitySVG,
  webhook: WebhookSVG,
  design: DesignSVG,
  workflow: WorkflowSVG,
  blueprint: BlueprintSVG,
  phase: PhaseSVG,
  automation: AutomationSVG,
  automation_circle: AutomationCircleSVG,
  journey: JourneySVG,
  relations: RelationsSVG,
  availability: AvailabilitySVG,
  filter: FilterSVG,
  sort: SortSVG,
  desktop: DesktopSVG,
  phone: PhoneSVG,
  image: ImageSVG,
  pause: PauseSVG,
  play: PlaySVG,
  alarm: AlarmSVG,
  arrow_circle_left: ArrowCircleLeftSVG,
  more_vert: MoreVertSVG,
  more_horiz: MoreHorizSVG,
  more_horiz_circle: MoreHorizCircleSVG,
  question_mark: QuestionMarkSVG,
  skip: SkipSVG,
  checklist: ChecklistSVG,
  person_check: PersonCheckSVG,
  person_add: PersonAddSVG,
  comment: CommentSVG,
  star: StarSVG,
  store: StoreSVG,
  exclamation: ExclamationSVG,
  primary: PrimarySVG,
  price_mapping: PriceMappingSVG,
  reply: ReplySVG,
  reply_all: ReplyAllSVG,
  resize: ResizeSVG,
  portal: PortalSVG,
  thumb_up: ThumbUpSVG,
  thumb_down: ThumbDownSVG,
  entity_builder: EntityBuilderSVG,
  connection: ConnectionSVG,
  check_box: CheckBoxSVG,
  number: NumberSVG,
  radio_button: RadioButtonSVG,
  text_field: TextFieldSVG,
  address: AddressSVG,
  signature: SignatureSVG,
  upload: UploadSVG,
  calculator: CalculatorSVG,
  payment: PaymentSVG,
  consent: ConsentSVG,
  paragraph: ParagraphSVG,
  action: ActionSVG,
  attribute_edit: AttributeEditSVG,
  summary: SummarySVG,
  solar: SolarSVG,
  sdk: SDKSVG,
  lookup: LookupSVG,
  previous_provider: PreviousProviderSVG,
  success_confirmation: SuccessConfirmationSVG,
  category: CategorySVG,
  expand_content: ExpandContentSVG,
  collapse_content: CollapseContentSVG,
  map: MapSVG,
  sun: SunSVG,
  frame: FrameSVG,
  energy_savings_leaf: EnergySavingsLeafSVG,
  avg_time: AvgTimeSVG,
  call: CallSVG,
  mail: MailSVG,
  cable: CableSVG,
  table_rows_narrow: StackSVG,
  two_columns: TwoColumnsSVG,
  diagram: DiagramSVG,
  repeat: RepeatSVG,
  move_down: MoveDownSVG,
  step_over: StepOverSVG,
  pending_actions: PendingSVG,
  pause_circle: PauseCircleSVG,
  condition: ConditionSVG,
  condition_circle: ConditionCircleSVG,
  note_stack: NoteStackSVG,
  double_thumbs_up: DoubleThumbsUpSVG,
  ai_star: AIStarSVG,
  ai_compose: AIComposeSVG,
  label: LabelSVG,
  label_off: LabelOffSVG,
  remove: RemoveSVG,
  file_manager: FileManagerSVG,
  bolt: BoltSVG,
  viewDay: ViewDaySVG,
  flip: FlipSVG,
  update: UpdateSVG,
  schedule: ScheduleSVG,
  calendar_clock: CalendarClockSVG,
  read_more: ReadMoreSVG,
  keep: KeepSVG,
  keep_off: KeepOffSVG,
  grid: GridSVG,
  grid_view: GridViewSVG,
  auto_delete: AutoDeleteSVG,
  delete_forever: DeleteForeverSVG,
  history: RestoreSVG,
  forest: ForestSVG,
  fuel: FuelSVG,
  recycling: RecyclingSVG,
  dangerous: DangerousSVG,
  apartment: ApartmentSVG,
  play_circle: PlayCircleSVG,
  add_task: AddTaskSVG,
  raven: RavenSVG,
  drive_file_move: DriveFileMoveSVG,
  merge: MergeSVG,
  archive: ArchiveSVG,
  unarchive: UnarchiveSVG,
  location_away: LocationAwaySVG,
  link_off: LinkOffSVG,
  account_circle_off: AccountCircleOffSVG,
  send: SendSVG,
  undo: UndoSVG,
  chip_extraction: ChipExtractionSVG,
  target: TargetSVG,
  campaign: CampaignSVG,
  ticket: TicketSVG,
  flow: FlowSVG,
  cards: CardsSVG,
  task: TaskSVG,
  widgets: WidgetsSVG,
  attach: AttachSVG,
  description: DescriptionSVG,
  stacked_email: StackedEmailSVG,
  chat_bubble: ChatBubbleSVG,
  globe: GlobeSVG,
  home: HomeSVG,
  euro: EuroSVG,
  toggle: ToggleSVG,
  numbers: NumbersSVG,
  building: BuildingSVG,
  move: MoveSVG,
  move_in: MoveInSVG,
  condition_graph: ConditionGraphSVG,
  feature_search: FeatureSearchSVG,
  synchronize: SynchronizeSVG,
  arrow_upward: ArrowUpSVG,
  arrow_downward: ArrowDownSVG,
  regular_expression: RegularExpressionSVG,
  inbox: InboxSVG,
  edit_document: EditDocumentSVG,
  left_panel_close: LeftPanelCloseSVG,
  left_panel_open: LeftPanelOpenSVG,
  hand: HandSVG,
  smart_toy: SmartToySVG,
  admin_panel_settings: AdminPanelSettingsSVG,
  sync: SyncSVG,
  sync_disabled: SyncDisabledSVG,
  do_not_disturb_on: DoNotDisturbOnSVG,
  swap: SwapSVG,
  expand: ExpandSVG,
  collapse: CollapseSVG,
  action_key: ActionKeySVG,
  bar_chart: BarChartSVG,
  database: DatabaseSVG,
  coupon: CouponSVG,
  product_recommendation: ProductRecommendationSVG,
  location: LocationSVG,
  labs: LabsSVG,
  format_bold: FormatBoldSVG,
  format_italic: FormatItalicSVG,
  format_underlined: FormatUnderlinedSVG,
  format_strikethrough: FormatStrikethroughSVG,
  heading: HeadingSVG,
  format_list_bulleted: FormatListBulletedSVG,
  format_list_numbered: FormatListNumberedSVG,
  code: CodeSVG,
  group: GroupSVG,
  folder_limited: FolderLimitedSVG,
  analytics: AnalyticsSVG,
  area_chart: AreaChartSVG,
  trending: TrendingSVG,
  library: LibrarySVG,
  chart_line: ChartLineSVG,
};

export type IconSVGName = keyof typeof svgMap;
type Opts = IconProps & {
  name: IconSVGName;
  xclass?: string;
};

const defaultOpts: Opts = {
  name: 'epilot',
  size: 24,
  fill: 'currentColor',
};

export const svgIcon = (opts: Opts): string => {
  const { name, ...restOpts } = {
    ...defaultOpts,
    ...opts,
  };

  const svg = svgMap[name];

  if (!svg) return '';

  // Each *SVG builder already applies size/width/height/fill/xclass/variant,
  // so no DOM parsing is needed.
  return svg(restOpts as SvgStringOpts);
};
